export default __webpack_public_path__ + "static/media/previous_surgery.aee639de.png";